import React from 'react';

export default function Home() {
  return (
    <div className='page-card'>
      <h1>About Marcus</h1>
      <p>
        <img className="img-fluid mx-auto d-block" src={require("../images/marcus profile pic.jpg")} width="450" height="350" alt="" /> 
        A highly dedicated and growth-focused professional with a recently completed MERN Full Stack web development program. Committed to crafting, developing, and delivering unique, custom software solutions that solve businesses' most challenging problems using a combination of industry standards, such as HTML, CSS, JavaScript, Python, Node.js, AWS, Mysql, Mongo DB, Visual Studio. Strong time-management and organizational skills with a commitment to clean and efficient coding practices. Being a versatile and quick learner, I eagerly embrace new challenges and continuously seek opportunities to expand my knowledge in the software engineering field. My commitment to growth and improvement drives me to excel in every project I undertake. Let's work together to create innovative solutions that make a real impact in the software development world!


      </p>
    
    </div>
  );
}
